import {
  EReservationTransfer,
  reservationTransfer,
} from 'modules/accommodations/features/reservations/components/ReservationAddNew/ReservationSteps/consts';

export const getTransferName = (transferName: string) => {
  switch (transferName) {
    case EReservationTransfer.GA:
      return reservationTransfer.GA;
    case EReservationTransfer.GI:
      return reservationTransfer.GI;
    case EReservationTransfer.AI:
      return reservationTransfer.AI;
    case EReservationTransfer.AG:
      return reservationTransfer.AG;
    case EReservationTransfer.IA:
      return reservationTransfer.IA;
  }
};
